<template>
  <div>
    <v-btn large>Cancel</v-btn>
  </div>
</template>

<script>
export default {
  name: "CancelButton"
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/variables.scss";
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: $cancel-color;
  color: black;
  display: block;
  border-radius: 20px;
  width: $width-button;
  border: 1px solid $cancel-color;
  margin: $margin-button;
  height: $height-button;
}
</style>
